import React from "react";
import { useTheme } from "../../../ThemeContext";

const SectionDropdown = ({ value = [], onChange }) => {
  const { theme } = useTheme();

  // Options for the dropdown
  const options = [
    "Pile - V", "Pile - S", "Pile - I",
    "Pile Cap - S", "Pile Cap - V", "Pile Cap - I",
    "Pier", "Pier upto CL", "U Girder Casting",
    "U Girder Erection", "U Girder Casting S", "U Girder Erection S",
    "Pre I Girder Casting", "Pre I Girder Erection",
    "Post I Girder Casting", "Post I Girder Erection",
    "Pier Cap Casting", "Pier Cap Erection",
    "Concourse Level Pier Cap Casting", "Deck Slab",
    "Spine Casting", "Spine Erection", "Wing Casting",
    "Soil Investigation - S", "Soil Investigation - V",
    "Utility Identification - S", "Utility Identification - V",
    "Portal Beam Casting", "Portal Beam Erection",
    "Concourse Portal Beam Casting", "Concourse Portal Beam Erection",
    "Cast-in-situ Piercap Casting", "Flair",
    "Platform Pier", "PPC Casting", "PPC Erection",
    "CPC Casting", "CPC Erection", "2 Piece CPC Casting",
    "2 Piece CPC Erection", "PI Girder Casting", "PI Girder Erection",
    "Iconic Segment Casting", "Segment beyond IL&FS",
    "T Girder Casting",
  ];

  // Handle changes in the multi-select
  const handleChange = (e) => {
    const selectedOptions = Array.from(e.target.selectedOptions).map(
      (option) => option.value
    );
    onChange(selectedOptions); // Pass the array of selected values to the parent
  };

  return (
    <div>
      <label
        htmlFor="section-dropdown"
        className={`block mb-2 text-sm font-medium ${
          theme === "dark" ? "text-white" : "text-gray-700"
        }`}
      >
        Select Structures
      </label>
      <select
        id="section-dropdown"
        value={value}
        multiple
        onChange={handleChange}
        className={`w-full p-2 text-sm border font-sm rounded-md focus:ring-2 focus:ring-blue-500 ${
          theme === "dark"
            ? "bg-gray-700 text-white border-gray-600"
            : "bg-white text-gray-700 border-gray-300"
        }`}
      >
        {options.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
    
    </div>
  );
};

export default SectionDropdown;
